import React from 'react'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next'
import { TabProps } from '../../../models/Sample'
import { ViewSampleDetailsRow } from './ViewSampleDetailsRow'
import { AppUtil } from '../../../utils/app.utils'

export const QC = (props: TabProps) => {
  const { sampleDetails } = props
  const { t } = useTranslation()
  const translatn = 'viewSample.'
  const parentClass = ''
  const detailsArr = [
    {
      label: t(`${translatn}qcCheck`),
      value: AppUtil.convertBooleanToStr(sampleDetails?.qcCheck ?? ''),
      row: 1,
    },
    {
      label: t(`${translatn}pathogenFreeReport`),
      value: AppUtil.convertBooleanToStr(sampleDetails?.pathogenFreeReport ?? ''),
      row: 1,
    },
  ]

  const rowCount = [1]

  return (
    <Container fluid>
      <h5> {t(`${translatn}qc`)}</h5>
      {rowCount.map((row, index) => (
        <ViewSampleDetailsRow
          key={row}
          index={index}
          rowArr={detailsArr.filter((details) => details.row == row)}
          parentClass={parentClass}
        />
      ))}
    </Container>
  )
}
